import { Space } from 'antd';
import styled from 'styled-components';

export const ScenarioModelingSpace = styled(Space)`
  & > .ant-space-item {
    flex: 1;
  }
  background: #f6f7fa;
`;
